const ROLES_FOR_APP = {
  DASHBOARD_VIEW: "view",

  USER_MANAGEMENT: "user_management",

  COMPANY_MANAGEMENT: "company_management",
  COMPANY_LIST: "company_list",
  COMPANY_CREATE: "company_create",
  COMPANY_UPDATE: "company_update",
  COMPANY_DELETE: "company_remove",

  APPLICATION_MANAGEMENT: "application_management",

  OPERATOR_LIST: "operator_management:operator:view",
  OPERATOR_CREATE: "operator_management:operator:view",
  OPERATOR_UPDATE: "operator_management:operator:view",
  OPERATOR_DELETE: "operator_management:operator:view",

  ROLE_LIST: "role_list",
  ROLE_CREATE: "role_create",
  ROLE_UPDATE: "role_update",
  ROLE_DELETE: "role_remove",

  USER_LIST: "user_list",
  USER_CREATE: "user_create",
  USER_UPDATE: "user_update",
  USER_DELETE: "user_remove",

  ACTIVITY_LOG_LIST: "operator_management:activity_log:view",

  SSO_LIST: "sso_list",
  SSO_MESSAGEHUB: "sso_messagehub",

  CONFIGURATION_LIST: "campaign_list",
  CONFIGURATION_CREATE: "campaign_create",
  CONFIGURATION_UPDATE: "campaign_update",
  CONFIGURATION_DELETE: "campaign_remove",

  AUDITION_MANAGEMENT: "audition_management",
  AUDITION_LIST: "audition_list",

  CATEGORY_LIST: "category_list",
  CATEGORY_CREATE: "category_create",
  CATEGORY_UPDATE: "category_update",
  CATEGORY_DELETE: "category_remove",
};

const isHavePermissionRole = (
  keyRoles: string | string[],
  permissions: string = "ADMIN"
): boolean => {
  if(permissions === "ADMIN") return true;

  const roles = typeof keyRoles === "string" ? [keyRoles] : keyRoles;
  return [ROLES_FOR_APP.APPLICATION_MANAGEMENT, ROLES_FOR_APP.AUDITION_MANAGEMENT]?.some(item => roles?.includes(item));
  // return permissions?.some((item) => roles?.includes(item.name));
};

export { ROLES_FOR_APP, isHavePermissionRole };
